import type { Country } from './common';

/**
 * https://en.wikipedia.org/wiki/National_identification_number#Denmark
 * https://en.wikipedia.org/wiki/Personal_identification_number_(Denmark)
 */
export class DK implements Country {
	private static readonly VALIDATION_REGEX = /^\d{6}-(\d{4}|[a-zæøå]{4})$/i;
	private static readonly TEMP_CPR_LAST_CHARS = /^[a-zæøå]{4}$/i;

	/** `DDMMYYSSSS`, the hyphen of `DDMMYY-SSSS` is often left out when typing */
	public readonly minLength = 10;

	public validate(input: string): boolean {
		const match = DK.VALIDATION_REGEX.test(input);
		if (!match) return false;

		if (this.isTempCPR(input)) return this.isBirthDateValid(input, '19');

		const birthCentury = Number(input[7]) > 4 ? '19' : '20';

		return this.isBirthDateValid(input, birthCentury);
	}

	public normalize(input: string): string {
		return input.toUpperCase();
	}

	public getDateOfBirth(): null {
		return null;
	}

	private isTempCPR(input: string): boolean {
		return DK.TEMP_CPR_LAST_CHARS.test(input.substring(7, 11));
	}

	private isBirthDateValid(input: string, century: string): boolean {
		const dateString = `${century}${input.substring(4, 6)}/${input.substring(2, 4)}/${input.substring(0, 2)}`;
		const birthDay = new Date(dateString);

		if (birthDay.toString() === 'Invalid Date' || parseInt(input.substring(2, 4)) !== birthDay.getMonth() + 1) {
			return false;
		}

		return true;
	}
}
